module.exports = __webpack_public_path__ + "img/s7Model4B.0c393a65.webp";